//@flow

import React, { Component } from 'react';
import InputRange from 'react-input-range';
import isEqual from 'lodash/isEqual';

import '../../../../node_modules/react-input-range/lib/css/index.css';

type Range = { min: number, max: number };
type Props = {
  data: Range,
  title: string,
  dataKey: string,
  step: number,
  defaultValue: Object,
  filterFn: Function,
  resetFn: Function,
};
type State = { [string]: Range };

export default class RangeFilter extends Component<Props, State> {
  state = { [ this.props.dataKey ]: { ...this.props.data } };

  handleChange = (value: Range) => this.setState({ [this.props.dataKey]: value });

  handleReduxStateChange = (value: Range) => this.props.filterFn(value);

  handleReset = () =>
    this.setState({ ...this.props.defaultValue }, () =>
      this.props.resetFn(this.state[this.props.dataKey])
    );

  componentDidUpdate(prevProps) {
    const { dataKey, data } = this.props;

    if (!isEqual(data, prevProps.data)) {
      if (!isEqual(data, this.state[dataKey])) {
        this.setState({ ...this.props.defaultValue });
      }
    }
  }

  render() {
    const { title, defaultValue, dataKey, step } = this.props;

    return (
      <div className="widget widget-range">
        <h4>
          {title}
          <span className="float-right" onClick={this.handleReset}>
            Reset
          </span>
        </h4>
        <InputRange
          minValue={defaultValue[dataKey].min}
          maxValue={defaultValue[dataKey].max}
          step={step}
          value={this.state[dataKey]}
          onChange={this.handleChange}
          onChangeComplete={this.handleReduxStateChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/TrekListings/TrekFilters/RangeFilter.jsx